import { SonnerToaster } from '@/lib/toast'
import { LAYER_Z_INDEX } from '@novelaide/ui/components/LayerHost'

// 全局 toast 容器。挂在 App 顶部一次，所有页面通过 Admin toast facade 调用。
// 主题跟随 shadcn dark/light:html.dark 时走深色。
export function Toaster() {
  return (
    <SonnerToaster
      theme="dark"
      position="top-right"
      richColors
      closeButton
      style={{ zIndex: LAYER_Z_INDEX.toast }}
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:bg-card group-[.toaster]:text-card-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg',
          description: 'group-[.toast]:text-muted-foreground',
          actionButton: 'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
          cancelButton: 'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground'
        }
      }}
    />
  )
}
